document.documentElement.classList.remove('no-js');
const toggle=document.querySelector('[data-menu-toggle]');
const nav=document.querySelector('[data-site-nav]');
if(toggle&&nav){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open);});}

(() => {
  const popup = document.querySelector('[data-welcome-popup]');
  if (!popup) return;

  const storageKey = popup.dataset.storageKey || 'cymru-welcome-offer';
  const delay = Number.parseInt(popup.dataset.delay || '1000', 10);
  const cookieName = storageKey.replace(/[^a-zA-Z0-9_-]/g, '_');

  const hasSeenPopup = () => {
    try {
      if (window.localStorage.getItem(storageKey) === 'seen') return true;
    } catch (error) {}
    return document.cookie.split('; ').some((item) => item.startsWith(`${cookieName}=seen`));
  };

  const rememberPopup = () => {
    try { window.localStorage.setItem(storageKey, 'seen'); } catch (error) {}
    document.cookie = `${cookieName}=seen; Max-Age=31536000; Path=/; SameSite=Lax`;
  };

  const closePopup = () => {
    rememberPopup();
    popup.hidden = true;
    document.body.classList.remove('popup-open');
  };

  if (hasSeenPopup()) return;

  window.setTimeout(() => {
    popup.hidden = false;
    document.body.classList.add('popup-open');
    const dialog = popup.querySelector('[role="dialog"]');
    if (dialog) dialog.focus();
  }, Number.isFinite(delay) ? delay : 1000);

  popup.querySelectorAll('[data-popup-close]').forEach((control) => {
    control.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup();
  });
})();

(() => {
  const initialiseHeroTyping = () => {
    const heading = document.querySelector('[data-typed-heading]');
    if (!heading || heading.dataset.typingInitialised === 'true') return;
    heading.dataset.typingInitialised = 'true';

    const lines = Array.prototype.slice.call(heading.querySelectorAll('[data-typed-line]'));
    if (!lines.length) return;

    // Android Chrome can report reduced-motion in situations where normal page
    // animations are still expected. Keep the typing effect enabled on Android,
    // while preserving the reduced-motion fallback on other platforms.
    const isAndroid = /Android/i.test(navigator.userAgent || '');
    if (isAndroid) document.documentElement.classList.add('is-android');
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion && !isAndroid) {
      lines.forEach((line) => {
        line.textContent = line.getAttribute('data-text') || line.textContent;
      });
      return;
    }

    const texts = lines.map((line) => line.getAttribute('data-text') || line.textContent || '');
    let lineIndex = 0;
    let charIndex = 0;
    let timer = null;

    lines.forEach((line) => {
      line.textContent = '';
      line.classList.remove('is-active', 'is-complete', 'has-caret');
    });
    heading.classList.add('is-typing');

    const typeNext = () => {
      const line = lines[lineIndex];
      const text = texts[lineIndex];
      if (!line) {
        heading.classList.remove('is-typing');
        lines[lines.length - 1].classList.add('has-caret');
        return;
      }

      line.classList.add('is-active');
      charIndex += 1;
      line.textContent = text.substring(0, charIndex);

      if (charIndex < text.length) {
        timer = window.setTimeout(typeNext, 62);
        return;
      }

      line.classList.remove('is-active');
      line.classList.add('is-complete');
      lineIndex += 1;
      charIndex = 0;
      timer = window.setTimeout(typeNext, 150);
    };

    timer = window.setTimeout(typeNext, 250);

    window.addEventListener('pagehide', () => {
      if (timer) window.clearTimeout(timer);
    }, { once:true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseHeroTyping, { once:true });
  } else {
    initialiseHeroTyping();
  }

  // Chrome on Android may restore a page from the back/forward cache without
  // firing DOMContentLoaded again. Re-initialise when the page becomes active.
  window.addEventListener('pageshow', () => {
    const heading = document.querySelector('[data-typed-heading]');
    if (heading && !heading.dataset.typingInitialised) initialiseHeroTyping();
  });
})();

(() => {
  const initialiseContactForm = (scope = document) => {
    const form = scope.querySelector ? scope.querySelector('#CymruContactForm') : null;
    if (!form || form.dataset.topicInitialised === 'true') return;

    const topicSelect = form.querySelector('[data-contact-topic]');
    const fieldGroups = Array.from(form.querySelectorAll('[data-topic-fields]'));
    if (!topicSelect || !fieldGroups.length) return;

    const updateFields = () => {
      const selectedTopic = topicSelect.value;

      fieldGroups.forEach((group) => {
        const isActive = group.dataset.topicFields === selectedTopic;
        group.hidden = !isActive;
        group.querySelectorAll('input, textarea, select').forEach((field) => {
          field.disabled = !isActive;
        });
      });
    };

    topicSelect.addEventListener('change', updateFields);
    form.dataset.topicInitialised = 'true';
    updateFields();
  };

  initialiseContactForm();
  document.addEventListener('shopify:section:load', (event) => initialiseContactForm(event.target));
})();


(() => {
  const initialiseHeroVideo = (scope = document) => {
    const video = scope.querySelector ? scope.querySelector('[data-hero-video]') : null;
    if (!video || video.dataset.heroVideoInitialised === 'true') return;
    video.dataset.heroVideoInitialised = 'true';

    const hero = video.closest('[data-hero-section]') || video.closest('.hero--video');
    const requestedRate = Number.parseFloat(video.dataset.playbackRate || '0.7');
    const playbackRate = Number.isFinite(requestedRate) ? Math.min(1, Math.max(0.5, requestedRate)) : 0.7;
    let retryTimer = null;
    let interactionArmed = false;

    const revealVideo = () => {
      if (!hero) return;
      hero.classList.remove('hero--video-loading');
      hero.classList.add('hero--video-ready');
    };

    const hideVideo = () => {
      if (!hero) return;
      hero.classList.add('hero--video-loading');
      hero.classList.remove('hero--video-ready');
    };

    const prepareVideo = () => {
      try {
        video.autoplay = true;
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.volume = 0;
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.playbackRate = playbackRate;
        video.defaultPlaybackRate = playbackRate;
      } catch (error) {}
    };

    const videoIsMoving = () => !video.paused && !video.ended && video.readyState >= 2;

    const disarmInteractionRetry = () => {
      if (!interactionArmed) return;
      interactionArmed = false;
      ['pointerdown','touchstart','mousedown','keydown','wheel','scroll'].forEach((eventName) => {
        window.removeEventListener(eventName, interactionRetry);
      });
    };

    const armInteractionRetry = () => {
      if (interactionArmed) return;
      interactionArmed = true;
      ['pointerdown','touchstart','mousedown','keydown','wheel','scroll'].forEach((eventName) => {
        window.addEventListener(eventName, interactionRetry, { passive: true, once: false });
      });
    };

    const attemptPlay = (forceLoad = false) => {
      prepareVideo();
      if (forceLoad && video.readyState === 0) {
        try { video.load(); } catch (error) {}
      }

      let playResult;
      try {
        playResult = video.play();
      } catch (error) {
        armInteractionRetry();
        return;
      }

      if (playResult && typeof playResult.then === 'function') {
        playResult.then(() => {
          if (videoIsMoving()) revealVideo();
          disarmInteractionRetry();
        }).catch(() => {
          // Brave and other privacy-focused browsers can block autoplay even
          // for muted video. Keep the hero dark, then retry on first interaction.
          hideVideo();
          armInteractionRetry();
        });
      }
    };

    function interactionRetry() {
      attemptPlay(true);
    }

    prepareVideo();
    hideVideo();

    // Only reveal once frames are actually advancing. This avoids a frozen
    // first frame being mistaken for a working background when autoplay is blocked.
    video.addEventListener('playing', () => {
      revealVideo();
      disarmInteractionRetry();
    });
    video.addEventListener('timeupdate', () => {
      if (video.currentTime > 0.02 && videoIsMoving()) revealVideo();
    });

    video.addEventListener('loadedmetadata', () => {
      prepareVideo();
      attemptPlay();
    });
    video.addEventListener('canplay', () => attemptPlay());
    video.addEventListener('canplaythrough', () => attemptPlay());
    video.addEventListener('stalled', () => armInteractionRetry());
    video.addEventListener('suspend', () => {
      if (!videoIsMoving()) armInteractionRetry();
    });
    video.addEventListener('pause', () => {
      if (!document.hidden && !video.ended) {
        hideVideo();
        clearTimeout(retryTimer);
        retryTimer = setTimeout(() => attemptPlay(), 120);
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) attemptPlay(true);
    });
    window.addEventListener('pageshow', () => attemptPlay(true));
    window.addEventListener('focus', () => attemptPlay());

    // Start immediately, then make two short retries. Browsers sometimes defer
    // media policy decisions until after page lifecycle events have settled.
    attemptPlay(true);
    setTimeout(() => { if (!videoIsMoving()) attemptPlay(); }, 350);
    setTimeout(() => { if (!videoIsMoving()) attemptPlay(); }, 1200);

    // If autoplay is still blocked, the first normal visitor interaction retries it.
    setTimeout(() => { if (!videoIsMoving()) armInteractionRetry(); }, 1400);
  };

  initialiseHeroVideo();
  document.addEventListener('shopify:section:load', (event) => initialiseHeroVideo(event.target));
})();


// CC 2.33: Keep the complete announcement + navigation area fixed to the top.
// A measured spacer preserves the original document flow so page content never
// jumps underneath the fixed header, including when the mobile menu changes size.
(() => {
  const initFixedHeader = () => {
    const shell = document.querySelector('[data-cc-sticky-shell]');
    const spacer = document.querySelector('[data-cc-sticky-spacer]');
    if (!shell || !spacer) return;

    const sync = () => {
      const height = Math.ceil(shell.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--cc-sticky-shell-height', `${height}px`);
      spacer.style.height = `${height}px`;
    };

    sync();
    requestAnimationFrame(sync);
    setTimeout(sync, 100);
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('orientationchange', () => setTimeout(sync, 120), { passive: true });
    window.addEventListener('pageshow', sync);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(sync);
      observer.observe(shell);
    }

    document.addEventListener('shopify:section:load', () => setTimeout(sync, 0));
    document.addEventListener('shopify:section:reorder', () => setTimeout(sync, 0));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFixedHeader, { once: true });
  } else {
    initFixedHeader();
  }
})();
